import { render, staticRenderFns } from "./m-nav-carousel.vue?vue&type=template&id=2e9a261b&scoped=true&v-if=collection%20%26%26%20collection.length%20%3E%201"
import script from "./m-nav-carousel.vue?vue&type=script&lang=js"
export * from "./m-nav-carousel.vue?vue&type=script&lang=js"
import style0 from "./m-nav-carousel.vue?vue&type=style&index=0&id=2e9a261b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9a261b",
  null
  
)

export default component.exports